import React from 'react';

const RandomizerEnvironment = ({ state, callbacks }) => {
  const settings = state.randomizerSettings.environment || { frameInterval: 30 };

  return (
    <div className="w-full bg-transparent p-0 space-y-4">
      <p className="text-sm text-dark-text-muted leading-relaxed">
        Wechselt zufällig zwischen verfügbaren HDR-Hintergründen während des Exports. Die HDR-Dateien werden aus dem <code className="text-xs text-dark-text font-mono bg-dark-panel-light px-1.5 py-0.5 rounded">hdri</code> Ordner geladen.
      </p>

      {state.randomizers.environment && (
        <>
          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-secondary tracking-tight">Frame-Intervall</label>
            <input
              type="number"
              value={settings.frameInterval}
              onChange={(e) => callbacks.setRandomizerSettings({
                ...state.randomizerSettings,
                environment: {
                  ...settings,
                  frameInterval: parseInt(e.target.value) || 30
                }
              })}
              min="1"
              step="1"
              className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
            />
            <p className="mt-1.5 text-xs text-dark-text-muted">
              Alle {settings.frameInterval} Frames wird ein neuer HDR-Hintergrund gewählt
            </p>
          </div>

          {state.lighting.environment.customHDRUrl && (
            <div className="p-3 bg-white border border-dark-border rounded-lg">
              <p className="text-sm text-dark-text-secondary m-0 leading-relaxed">
                ⚠️ Eine eigene HDR-Datei ist aktiviert. Deaktivieren Sie diese, um die Randomisierung zu verwenden.
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RandomizerEnvironment;

